import styled from "styled-components";
import designSystemColors from "../../styles";

export const FormWrapper = styled.div`
  > form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  margin-top: 8px;
  border-top: 1px solid ${designSystemColors.border.modalDivider};
  padding-top: 16px;

  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
